import { ShareLink } from "components/ShareLink";

interface Props {
  xtmQaReportName: string;
  xtmQaReportUrl: string;
}

const XtmQaReportLink = ({ xtmQaReportUrl, xtmQaReportName }: Props) => {
  return <ShareLink url={xtmQaReportUrl} label={xtmQaReportName} isLoading={false} canCopy={true} />;
};

export default XtmQaReportLink;
